import { FileUpload } from "primereact/fileupload";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Button, FlexColumnAlignCenter, GenericButton, IconDispatcher, Label } from "shared/ui-basics";
import styled from "styled-components";
interface UploadFileProps {
	isDisable: boolean;
    stopRetrieveData:boolean;
    setIsFile:React.SetStateAction<boolean>;
    setValidFile:React.SetStateAction<boolean>;
    templateExportService:  () => void; 
    fileUploadRef: React.RefObject<HTMLInputElement>; 
}

export const UploadFile: React.FC<UploadFileProps> = ({ isDisable,stopRetrieveData ,setIsFile,setValidFile,templateExportService,fileUploadRef}) => {

	const { t } = useTranslation();

    const chooseOptions = { icon: IconDispatcher("UPLOAD"), iconOnly: true, className: "custom-choose-btn p-button-transparent" };
	const cancelOptions = { icon: IconDispatcher("trash"), iconOnly: true, className: "custom-choose-btn p-button-transparent" };

    const headerTemplate = (options:any) => {
		const { className, chooseButton, cancelButton } = options;
		return (
			<WrapperHeader className={className}>
				<div>
					<Button  size='s' variant="light-link" onClick={downloadTemplateFile}>
                    {IconDispatcher("FILE-XLS-LIGHT", "me-2")}

						{t("GET_FILE_TEMPLATE")}
					</Button>
				</div>
				<div>
					{chooseButton}
					{cancelButton}
				</div>
			</WrapperHeader>
		);
	};
    const downloadTemplateFile = () => {
		templateExportService();
	};
    const emptyView = () => {
        return (
            <FlexColumnAlignCenter style={{fontSize:'14px'}}>
                {stopRetrieveData? (
                    <div>{t("START_RETRIEVING_DEC")}</div>
                ) : (
                    <>
                        {IconDispatcher("FILE-XLS-THIN", "", { size: "2xl" })}
                        <Label className="my-2" color={"#333333"} size={14}>
                            {t("DRAG_DROP_FILE")}
                        </Label>
                    </>
                )}
            </FlexColumnAlignCenter>
        );
    };
    const itemTemplate = (file) => {
		return (
			<>
				<div className="p-fileupload-filename">{file.name}</div>
				<span></span>
			</>
		);
	};
    const eventOnFile=(haveFile)=>{
        setIsFile&& setIsFile(haveFile);
        setValidFile&& setValidFile(true);
  
    }
    return <FileUpload
        ref={fileUploadRef}
        name="demo[]"
        accept=".xlsx"
        maxFileSize={5000000}
        disabled={isDisable && stopRetrieveData}
        emptyTemplate={emptyView}
        customUpload={true}
        headerTemplate={headerTemplate}
        chooseOptions={chooseOptions}
        cancelOptions={cancelOptions}
        itemTemplate={itemTemplate}
        onSelect={() => {
            eventOnFile(true);
        }}
        onClear={() => {
            eventOnFile(false);
        }}
    />

};
// UploadFile.displayName = "UploadFile";
// export default UploadFile;

const WrapperHeader = styled.div<HTMLDivElement>`
	background-color: transparent;
	display: flex;
	justify-content: space-between;
	align-items: center;
    font-size: 14px;
`;
